import { render, staticRenderFns } from "./PFCustomerContact.vue?vue&type=template&id=676d158a"
import script from "./PFCustomerContact.vue?vue&type=script&lang=js"
export * from "./PFCustomerContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports